import styled from 'styled-components';

const LinkSpan = styled.span`
  color: #fca92a;
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.3s ease-in-out;

  :hover {
    color: #fafafa;
  }
`;

const EmailInvalidToast = ({
  goToLogin,
  hasPartnerCode = false,
}: {
  goToLogin: () => void;
  hasPartnerCode?: boolean;
}) =>
  hasPartnerCode ? (
    <div>
      This email already has an Enki account.{' '}
      <LinkSpan onClick={goToLogin}>Log in</LinkSpan> and your access code will
      be activated.
    </div>
  ) : (
    <div>
      Sorry, this email is not available. Try{' '}
      <LinkSpan onClick={goToLogin}>logging in</LinkSpan> instead.
    </div>
  );

export default EmailInvalidToast;
